import { useEffect, useState } from "react";

/**
 * An image that tries a list of sources in order and gives up quietly.
 *
 * Two things need this. A YouTube poster comes in two flavours and only the
 * better one might exist, and some older portfolio uploads have lost their
 * stored file — either way the frame should fall through to whatever comes
 * next, and land on the caller's placeholder rather than a broken icon.
 */
export default function CoverImage({ sources = [], alt = "", className, fallback = null }) {
  const list = sources.filter(Boolean);
  const [attempt, setAttempt] = useState(0);

  // A new item in the same frame starts over — otherwise it inherits the last
  // one's failures and shows the placeholder for an image that would have loaded.
  useEffect(() => { setAttempt(0); }, [list.join("|")]);

  if (attempt >= list.length) return fallback;

  return (
    <img
      src={list[attempt]}
      alt={alt}
      loading="lazy"
      onError={() => setAttempt(a => a + 1)}
      className={className}
    />
  );
}
